import { generateClassName } from '@klv/shared/utils/functions';
import Image from '@klv/atoms/image';
import KlaviyoFormAtom from '@klv/atoms/klaviyo-form';

import * as s from './styles/formsCta.module.scss';

import type { IFormsCta } from './types';

const FormsCta = ({ formId, backgroundColor = 'light', image }: IFormsCta) => {
  const hasImage = !!image?.gatsbyImage;

  return (
    <div
      className={
        generateClassName([
          s.formsCta,
          s[backgroundColor],
          'defaultPaddingTop',
          'defaultPaddingBottom'
        ])
      }
    >
      <div className={generateClassName([s.contentWrapper, 'grid'])}>
        {hasImage && image?.gatsbyImage && (
          <div className={s.imageWrapper}>
            <Image altText={image.altText} imageData={image.gatsbyImage} />
          </div>
        )}
        <div
          className={
            generateClassName([
              s.formWrapper,
              hasImage && s.hasImage,
              'grid'
            ])
          }
        >
          <KlaviyoFormAtom formId={formId} />
        </div>
      </div>
    </div>
  );
};

export default FormsCta;
